import React, { useState } from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./invoice.css";
import { useNavigate } from "react-router-dom";
let Invoice = () => {
  const navigate = useNavigate();
  let ActionHandler = (e) => {
    console.log(e.target.value);
    if (e.target.value === "View") {
      navigate("/invoice/view");
    } else if (e.target.value === "Edit") {
      navigate("/invoice/create", {
        state: { type: "edit" },
      });
    }
  };
  let [TableData, setTableData] = useState([
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$2000",
      status: "Due in 22 days",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$5000",
      status: "Paid",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Due in 22 days",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Overdue",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$2000",
      status: "Due in 22 days",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$5000",
      status: "Paid",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Due in 22 days",
    },
    {
      date: "JAN 4, 2022",
      id: "#12345678",
      studentName: "Willow Anderson",
      des: "Lorem ipsum dolor sit a...",
      amount: "$3000",
      status: "Overdue",
    },
  ]);
  return (
    <SideMenu>
      <div className="page-container">
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={8} lg={8} md={8} sm={12} xs={12}></Grid>
              <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                <Button className="header-button" variant="text">
                  <p className="page-header-button-text">Download</p>
                </Button>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
                <Button
                  className="header-button"
                  variant="text"
                  onClick={() => {
                    navigate("/invoice/create", {
                      state: { type: "add" },
                    });
                  }}
                >
                  <p className="page-header-button-text">+ Creat new Invoice</p>
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
                <div>
                  <p className="header-input-heading">Search by Invoice ID</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Search by Invoice ID"
                  />
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
                <div>
                  <p className="header-input-heading">Student Name</p>
                  <input
                    type="text"
                    className="header-input"
                    placeholder="Search by name"
                  />
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                <div>
                  <p className="header-input-heading">Status</p>
                  <select className="header-dropdown">
                    <option value="all">All</option>
                    <option value="Paid">Paid</option>
                    <option value="Overdue">Overdue</option>
                  </select>
                </div>
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                <DateRangePicker />
              </Grid>
              <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
                <div>
                  <Button className="header-apply-button" variant="text">
                    <p className="header-apply-button-text">Apply</p>
                  </Button>
                </div>
              </Grid>
            </Grid>
            <br />
          </Box>
          <br />
          <div className="table-container">
            <div className="table-data-container">
              <table>
                <thead>
                <tr>
                  <th className="invoice-table-date-heading" style={{paddingLeft:"10px"}}>Date</th>
                  <th className="invoice-table-id-heading" style={{paddingLeft:"0"}}>Invoice ID</th>
                  <th className="invoice-table-student-name-heading">
                    Student Name
                  </th>
                  <th className="invoice-table-description-heading">
                    Discription
                  </th>
                  <th className="invoice-table-amount-heading">amount</th>
                  <th className="invoice-table-status-heading">Status</th>
                  <th className="invoice-table-action-heading"></th>
                  <th className="invoice-table-send-heading"></th>
                </tr>
                </thead>
                {TableData.map((tableValue, tableIndex) => {
                  return (
                    <tr key={tableIndex}>
                      <td className="table-date-data">{tableValue.date}</td>
                      <td className="table-data">{tableValue.id}</td>
                      <td className="table-data">{tableValue.studentName}</td>
                      <td className="table-data">{tableValue.des}</td>
                      <td className="table-center-data">{tableValue.amount}</td>
                      <td className="table-data">
                        <div
                          className="invoice-table-status-button"
                          style={{
                            backgroundColor:
                              tableValue.status === "Paid"
                                ? "#098B51"
                                : tableValue.status === "Overdue"
                                ? "#EB4040"
                                : "#663399",
                            color: "#fff",
                          }}
                        >
                          {tableValue.status}
                        </div>
                      </td>
                      <td className="table-data">
                        <select
                          className="table-action-dropdown"
                          onChange={ActionHandler}
                        >
                          <option value="">Action</option>
                          <option value="View">View</option>
                          <option value="Edit">Edit</option>
                          <option value="Delete">Delete</option>
                        </select>
                      </td>
                      <td className="table-data">
                        <div className="invoice-table-send-button-main">
                          <Button className="invoice-table-send-button">
                            Send
                          </Button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
            <div className="table-pagination-main">
              <Stack spacing={2}>
                <Pagination count={10} variant="outlined" shape="rounded" />
              </Stack>
            </div>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default Invoice;
